const ProductEntity = (backClient) => ({
  index: async () => await backClient.get(`/api/products`),
})

export default ProductEntity
